export const biddingData = [
  {
    bidder: [
      {
        id: "1",
        name: "Joder Thing",
        avatar:
          "https://res.cloudinary.com/djisilfwk/image/upload/v1642264443/Minto%20NFT%20Marketplace/avatars/joe_west.jpg",
        amount: "1890 MINTO",
        date: "15 January, 2022",
        time: "5:40",
      },
      {
        id: "2",
        name: "Juhi",
        avatar:
          "https://res.cloudinary.com/djisilfwk/image/upload/v1642264442/Minto%20NFT%20Marketplace/avatars/juhi.jpg",
        amount: "1000 MINTO",
        date: "15 January, 2022",
        time: "5:40",
      },
      {
        id: "3",
        name: "Michail",
        avatar:
          "https://res.cloudinary.com/djisilfwk/image/upload/v1642264443/Minto%20NFT%20Marketplace/avatars/michail.jpg",
        amount: "900 MINTO",
        date: "15 January, 2022",
        time: "5:40",
      },
      {
        id: "4",
        name: "Madison",
        avatar:
          "https://res.cloudinary.com/djisilfwk/image/upload/v1642264441/Minto%20NFT%20Marketplace/avatars/maddy.jpg",
        amount: "1500 MINTO",
        date: "15 January, 2022",
        time: "5:40",
      },
      {
        id: "5",
        name: "Alex Garcia",
        avatar:
          "https://res.cloudinary.com/djisilfwk/image/upload/v1642264441/Minto%20NFT%20Marketplace/avatars/alexa_garcia.jpg",
        amount: "2200 MINTO",
        date: "15 January, 2022",
        time: "5:40",
      },
    ],
    acceptee: [
      {
        id: "1",
        name: "Alex Garcia",
        avatar:
          "https://res.cloudinary.com/djisilfwk/image/upload/v1642264441/Minto%20NFT%20Marketplace/avatars/alexa_garcia.jpg",
        amount: "500 MINTO",
        date: "15/06/2021",
        time: "5:40",
      },
      {
        id: "2",
        name: "Alex Garcia",
        avatar:
          "https://res.cloudinary.com/djisilfwk/image/upload/v1642264441/Minto%20NFT%20Marketplace/avatars/alexa_garcia.jpg",
        amount: "1500 MINTO",
        date: "15 January, 2022",
        time: "5:40",
      },
      {
        id: "3",
        name: "Maddy",
        avatar:
          "https://res.cloudinary.com/djisilfwk/image/upload/v1642264441/Minto%20NFT%20Marketplace/avatars/maddy.jpg",
        amount: "1000 MINTO",
        date: "15 January, 2022",
        time: "5:40",
      },
      {
        id: "4",
        name: "Maddy",
        avatar:
          "https://res.cloudinary.com/djisilfwk/image/upload/v1642264441/Minto%20NFT%20Marketplace/avatars/maddy.jpg",
        amount: "1100 MINTO",
        date: "15 January, 2022",
        time: "5:40",
      },
    ],
  },
];
